import { API } from 'aws-amplify'

export default async ids => {
  return API.del('process', '', { body: { processesIds: ids } })
}
